var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSunHigh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34296 17.657L4.92896 19.071M6.34296 6.34296L4.92896 4.92896M17.657 6.34296L19.071 4.92896M17.657 17.657L19.071 19.071M4 12H2M12 4V2M20 12H22M12 20V22M14.828 14.828C15.2101 14.459 15.5148 14.0176 15.7244 13.5296C15.9341 13.0416 16.0444 12.5167 16.049 11.9856C16.0537 11.4544 15.9525 10.9277 15.7513 10.4361C15.5502 9.94456 15.2532 9.49795 14.8776 9.12238C14.502 8.74681 14.0554 8.4498 13.5639 8.24867C13.0723 8.04755 12.5456 7.94634 12.0144 7.95096C11.4833 7.95557 10.9584 8.06592 10.4704 8.27555C9.98241 8.48519 9.54103 8.78992 9.17204 9.17196C8.44341 9.92637 8.04023 10.9368 8.04935 11.9856C8.05846 13.0344 8.47914 14.0376 9.22077 14.7792C9.9624 15.5209 10.9656 15.9415 12.0144 15.9507C13.0632 15.9598 14.0736 15.5566 14.828 14.828Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunHigh);
export default __webpack_public_path__ + "static/media/sun-high.df162dc0ef655986072926d5004234ca.svg";
export { ForwardRef as ReactComponent };